import { render, staticRenderFns } from "./complaintResult.vue?vue&type=template&id=86cd56c8&scoped=true&"
import script from "./complaintResult.vue?vue&type=script&lang=js&"
export * from "./complaintResult.vue?vue&type=script&lang=js&"
import style0 from "./complaintResult.vue?vue&type=style&index=0&id=86cd56c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cd56c8",
  null
  
)

export default component.exports